// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageWrapper_wrapper__1BUFJ","contentWrapper":"PageWrapper_contentWrapper__3NqAE","bottom-gradient":"PageWrapper_bottom-gradient__3u1X6"};